var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.127 3.56a.943.943 0 0 0-1.254 0c-.885.788-2.2.822-3.123.103v16.674a2.443 2.443 0 0 1 3.123.102.943.943 0 0 0 1.254 0 2.443 2.443 0 0 1 3.246 0 .943.943 0 0 0 1.254 0 2.443 2.443 0 0 1 3.246 0 .943.943 0 0 0 1.254 0 2.443 2.443 0 0 1 3.123-.102V3.663a2.444 2.444 0 0 1-3.123-.103.943.943 0 0 0-1.254 0 2.443 2.443 0 0 1-3.246 0 .943.943 0 0 0-1.254 0 2.443 2.443 0 0 1-3.246 0Zm-2.25-1.12a2.443 2.443 0 0 1 3.246 0 .943.943 0 0 0 1.254 0 2.443 2.443 0 0 1 3.246 0 .943.943 0 0 0 1.254 0 2.443 2.443 0 0 1 3.246 0 .943.943 0 0 0 1.254 0c.92-.818 2.373-.165 2.373 1.065v16.99c0 1.23-1.454 1.883-2.373 1.066a.943.943 0 0 0-1.254 0 2.443 2.443 0 0 1-3.246 0 .943.943 0 0 0-1.254 0 2.443 2.443 0 0 1-3.246 0 .943.943 0 0 0-1.254 0 2.443 2.443 0 0 1-3.246 0 .943.943 0 0 0-1.254 0c-.92.817-2.373.164-2.373-1.066V3.505c0-1.23 1.454-1.883 2.373-1.066a.943.943 0 0 0 1.254 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 15.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm0-3.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm0-3.5a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/Bill.559819be7fe6e14a14babf5e5228272e.svg";
export { ForwardRef as ReactComponent };